exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.estilo-grilla[data-v-eb6c343a] {\n  width: 100%;\n  height: 400px;\n  font-family: 'Asap', sans-serif;\n}\n", ""]);

// exports
